<template>
  <li class="the-detail__sitelist__item" v-on:click="showDetail" :class="{ 'active' : siteID == id}">
    <span class="the-detail__sitelist__item__name">
      {{name}}
    </span>
    <span class="the-detail__sitelist__item__updates dot" v-bind:class="{ 'dot--warning': extensions_need_update > 0 }">
      {{extensions_need_update}}
    </span>
  </li>
</template>
<script>

import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'SiteDetailSitelistItem',
  props: [
    'name',
    'extensions_need_update',
    'id'
  ],
  computed: {
    ...mapState('site', [
      'siteDetail'
    ]),
    siteID () {
      if (typeof this.siteDetail.data.id === 'undefined') {
        return ''
      }

      return this.siteDetail.data.id
    }
  },
  methods: {
    ...mapMutations('common', [
      'startLoading',
      'endLoading',
      'resetLoading',
      'showSidebar',
      'hideSidebar'
    ]),

    ...mapActions('site', [
      'setSiteDetailContent'
    ]),

    ...mapMutations('site', [
      'closeSiteDetailPage'
    ]),

    showDetail () {
      if (this.siteDetail.data.id !== this.id) {
        this.startLoading()
        this.setSiteDetailContent(this.id).then(() => {
          this.resetLoading()
        }
        )
      } else {
        this.showSidebar()
        this.closeSiteDetailPage()
      }
    }
  }
}

</script>
